import React from 'react';

import CircularLoading from '../../Common/CircularLoading/CircularLoading';

class SignUpMobileStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  update = (values) => {
    this.props.updateFormState(values);
  };

  render() {
    return (
      <div className="mobile-step-container">
        <div className="gradient-divider" />
        <div className="mobile-step-container-body">
          <div className="mobile-step-button-contaier">
            <div className="back-link">
              <span
                className="back-link-action"
                onClick={() => this.update({ mobileStep: false })}
              >
                back
              </span>
            </div>
            <button
              className="mobile-step-open-modal-btn btn btn-block"
              onClick={() => this.update({ isModalOpen: true })}
              disabled={this.props.loadingReferences}
            >
              {this.props.loadingReferences ? (
                <CircularLoading className="loading-free-trial-button" />
              ) : (
                'Get 3 Day Free Trial'
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default SignUpMobileStep;
